import { BinaryReader, BinaryWriter } from "../../../binary";
/** GenesisState - initial state of module */

/** GenesisState - initial state of module */

/** GenesisState - initial state of module */

/** Params defines the set of module parameters. */

/** Params defines the set of module parameters. */

/** Params defines the set of module parameters. */

function createBaseGenesisState() {
  return {
    params: Params.fromPartial({}),
    stakingContractAddresses: [],
    govContractAddresses: []
  };
}
export const GenesisState = {
  typeUrl: "/juno.cwhooks.v1.GenesisState",
  encode(message, writer = BinaryWriter.create()) {
    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.stakingContractAddresses) {
      writer.uint32(18).string(v);
    }
    for (const v of message.govContractAddresses) {
      writer.uint32(26).string(v);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.params = Params.decode(reader, reader.uint32());
          break;
        case 2:
          message.stakingContractAddresses.push(reader.string());
          break;
        case 3:
          message.govContractAddresses.push(reader.string());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$stakingContra, _object$govContractAd;
    const message = createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
    message.stakingContractAddresses = ((_object$stakingContra = object.stakingContractAddresses) === null || _object$stakingContra === void 0 ? void 0 : _object$stakingContra.map(e => e)) || [];
    message.govContractAddresses = ((_object$govContractAd = object.govContractAddresses) === null || _object$govContractAd === void 0 ? void 0 : _object$govContractAd.map(e => e)) || [];
    return message;
  },
  fromAmino(object) {
    var _object$staking_contr, _object$gov_contract_;
    const message = createBaseGenesisState();
    if (object.params !== undefined && object.params !== null) {
      message.params = Params.fromAmino(object.params);
    }
    message.stakingContractAddresses = ((_object$staking_contr = object.staking_contract_addresses) === null || _object$staking_contr === void 0 ? void 0 : _object$staking_contr.map(e => e)) || [];
    message.govContractAddresses = ((_object$gov_contract_ = object.gov_contract_addresses) === null || _object$gov_contract_ === void 0 ? void 0 : _object$gov_contract_.map(e => e)) || [];
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.params = message.params ? Params.toAmino(message.params) : undefined;
    if (message.stakingContractAddresses) {
      obj.staking_contract_addresses = message.stakingContractAddresses.map(e => e);
    } else {
      obj.staking_contract_addresses = [];
    }
    if (message.govContractAddresses) {
      obj.gov_contract_addresses = message.govContractAddresses.map(e => e);
    } else {
      obj.gov_contract_addresses = [];
    }
    return obj;
  },
  fromAminoMsg(object) {
    return GenesisState.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return GenesisState.decode(message.value);
  },
  toProto(message) {
    return GenesisState.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.cwhooks.v1.GenesisState",
      value: GenesisState.encode(message).finish()
    };
  }
};
function createBaseParams() {
  return {
    contractGasLimit: BigInt(0)
  };
}
export const Params = {
  typeUrl: "/juno.cwhooks.v1.Params",
  encode(message, writer = BinaryWriter.create()) {
    if (message.contractGasLimit !== BigInt(0)) {
      writer.uint32(8).uint64(message.contractGasLimit);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.contractGasLimit = reader.uint64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseParams();
    message.contractGasLimit = object.contractGasLimit !== undefined && object.contractGasLimit !== null ? BigInt(object.contractGasLimit.toString()) : BigInt(0);
    return message;
  },
  fromAmino(object) {
    const message = createBaseParams();
    if (object.contract_gas_limit !== undefined && object.contract_gas_limit !== null) {
      message.contractGasLimit = BigInt(object.contract_gas_limit);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.contract_gas_limit = message.contractGasLimit ? message.contractGasLimit.toString() : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return Params.decode(message.value);
  },
  toProto(message) {
    return Params.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.cwhooks.v1.Params",
      value: Params.encode(message).finish()
    };
  }
};